import barba from '@barba/core'

export const filters = () => {
	dropdowns()
	search()
}

const dropdowns = () => {

	const form = document.querySelector('#resources-filter-form')
	if (!form) return false

	const selects = form.querySelectorAll('select')
	if (!selects.length) return false

	// Get base URL from data attribute - this should always be set by PHP
	let baseUrl = form.getAttribute('data-base-url')
	
	// If baseUrl is not set or empty, try to find resources page link or use a fallback
	if (!baseUrl || baseUrl.trim() === '') {
		// Try to find a link to resources page in the page
		const resourcesLink = document.querySelector('a[href*="/resources"]')
		if (resourcesLink) {
			const href = resourcesLink.getAttribute('href')
			// Extract just the pathname from the href
			try {
				const url = new URL(href, window.location.origin)
				baseUrl = url.pathname
			} catch (e) {
				baseUrl = href.split('?')[0] // Remove query params if any
			}
		} else {
			// Last resort fallback
			baseUrl = '/resources/'
		}
	}

	const buildFilterUrl = () => {
		const params = new URLSearchParams()
		
		selects.forEach(select => {
			const value = select.value.trim()
			if (value) {
				// Determine which parameter name based on select ID
				if (select.id === 'category_library_filter') {
					params.set('category', value)
				} else if (select.id === 'format_library_filter') {
					params.set('format', value)
				}
			}
		})

		// Build the URL with query parameters
		// Handle both absolute URLs (with domain) and relative URLs
		let baseUrlPathname
		try {
			// Try to parse as absolute URL first
			if (baseUrl.startsWith('http://') || baseUrl.startsWith('https://')) {
				const urlObj = new URL(baseUrl)
				baseUrlPathname = urlObj.pathname
			} else {
				// Relative URL - use current origin as base
				const urlObj = new URL(baseUrl, window.location.origin)
				baseUrlPathname = urlObj.pathname
			}
		} catch (e) {
			// Fallback: treat as relative path
			baseUrlPathname = baseUrl.split('?')[0] // Remove any query params
		}
		
		const queryString = params.toString()
		
		// Return the pathname with query string
		return baseUrlPathname + (queryString ? `?${queryString}` : '')
	}

	selects.forEach(select => {
		select.addEventListener('change', function () {
			const url = buildFilterUrl()
			// barba.go(url)
			location.href = url
		})
	})
}

const search = () => {

	const els = document.querySelectorAll('[data-el="search"]')

	if (!els.length) return

	els.forEach(el => {
		el.addEventListener('submit', e => {

			e.preventDefault()

			const input = el.querySelector('input[name="s"]')
			const query = input.value.trim()

			if (!query) return

			const url = `/ ?s=${encodeURIComponent(query)}`

			// barba.go(url)
			location.href = url

		})
	})
}

export default () => { }